import { Component } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { map } from 'rxjs/operators';
import { CustomTwoSquareSelectionData } from './custom-two-square-selection.model';

@Component({
  selector: 'app-custom-two-square-selection',
  templateUrl: './custom-two-square-selection.component.html',
  styleUrls: ['./custom-two-square-selection.component.scss'],
  standalone: false
})
export class CustomTwoSquareSelectionComponent {
  constructor(
    protected componentData: CmsComponentData<CustomTwoSquareSelectionData>,
    private cmsService: CmsService
  ) { }

  data$ = this.componentData.data$.pipe(map(component => component));
}
